const subExamListReducer = (state = {}, action = {}) => {
    if (action.type === 'GET_CHILD_CATEGORY') {
        return action.payload;
    }
    return state;
}

export default subExamListReducer;
